<template>
  <div class="vx-card p-6 minus-top">
    <div class="vx-col md:w-1/2 mt-2 w-full mb-2">
      <span class="title-page">{{$t('button.trackingToSpecialNews')}}</span>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-2/3 w-full mt-2">
        <vs-button icon-pack="feather" type="border" @click="openPopupCreate">{{$t('warningManager.newSource')}}</vs-button>
      </div>
      <div class="vx-col md:w-1/3 w-full mt-2">
        <div style="float:right">
        <vs-button  type="border" color ="warning" @click="$router.go(-1)">{{$t('warningManager.back')}}</vs-button>
        </div>
      </div>
    </div>

    <div class="rows">
        <div class="vx-row">
        <div class="vx-col w-full mt-2">
              <div class="vx-row" style="">
                <div class="vx-col md:w-5/6 w-full mt-2" style="max-width:80%">
                  <span class="text-topic">{{$t('warningManager.source')}}</span>
              </div>

              <div class="vx-col md:w-1/6 w-full mt-2" style="max-width:20%">
                  <span class="text-topic">{{$t('warningManager.manipulation')}}</span>
              </div>
              </div>
          </div>
      </div>
      </div>

     <div class="row">
        <div class="vx-row" v-for="(item,index) in responseData" :key="index">
          <div class="vx-col w-full mt-2">
              <div class="rows-1" v-if="index%2 ==0">
                <div class="vx-row">
                <div class="vx-col md:w-5/6 w-full mt-2" style="max-width:80%">
                  <span class="">{{item.articleResource}}</span>
                </div>

              <div class="vx-col md:w-1/6 w-full mt-2" style="max-width:20%">
                  <feather-icon  class="icon" icon="EditIcon" @click="editArticle(item.id)"/>
                  <feather-icon  class="icon" icon="TrashIcon" @click="confirmDelete(item.id)"></feather-icon>
              </div>
              </div>
              </div>

              <div class="rows-2" v-else>
                <div class="vx-row">
                <div class="vx-col md:w-5/6 w-full mt-2" style="max-width:80%">
                  <span class="">{{item.articleResource}}</span>
                </div>

              <div class="vx-col md:w-1/6 w-full mt-2" style="max-width:20%">
                  <feather-icon  class="icon" icon="EditIcon" @click="editArticle(item.id)"/>
                  <feather-icon  class="icon" icon="TrashIcon" @click="confirmDelete(item.id)"></feather-icon>
              </div>
              </div>
              </div>
          </div>
      </div>
      </div>

      <vs-popup  class="popup" classContent="popup-example" :title="`${this.isUpdate ?  $t('warningManager.updateSource') :  $t('warningManager.createNewSource')}`" :active.sync="openPopup">
        <div class="vx-row">
          <div class="vx-col w-full mt-2">
            <label> {{$t('warningManager.source')}}</label>
            <vs-input
            class="w-full"
            v-model="form.articleResource"
            v-validate ="'required|url'"
            data-vv-validate-on="blur"
            name="article"
            ></vs-input>
          </div>
           <span class="text-danger text-sm message-error">
                    {{errors.first("article")}}
            </span>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mt-2">
            <label>{{$t('warningManager.note')}}</label>
            <vs-textarea
            v-model="form.description"
            >
            </vs-textarea>
          </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{`${isUpdate ?
                  $t('button.update'): $t('button.createNew')}`}}
                </vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="openPopup = false">{{$t('warningManager.back')}}
                </vs-button>
              </div>
            </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
export default {
components:{

},
data(){
  return{
    article:null,
    description:null,

    openPopup:false,

    isUpdate:false,
    form:{
      id:null,
      articleResource:null,
      description:null
    },
    responseData:{},
  }
},
computed:{
  validateForm:function(){
    return !this.errors.any();
  }
},
async created(){
  this.initScreen();
},
methods: {
  initScreen: function () {
    this.getLists();
  },
  saveChanges: function () {
    const payloadCreate = {
      articleResource: this.form.articleResource,
      description: this.form.description
    }
    const payloadUpdate = {
      id: this.form.id,
      articleResource: this.form.articleResource,
      description: this.form.description
    }
    if(!this.form.articleResource){
      return this.$vs.notify({
        text: this.$t('warningManager.textSource'),
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      });
    }
    const payload = this.isUpdate ? payloadUpdate : payloadCreate;
    const path = this.isUpdate ? '/following-special-article/update' : '/following-special-article/create';
    this.$processor.post(path, payload).then((response) => {
      this.$vs.notify({
        text: `${this.isUpdate ? this.$t('warningManager.update') : this.$t('warningManager.add')} ` +  ` ${this.$t('warningManager.success')}`,
        icon: 'feather',
        iconPack: 'icon-alert-circle',
        color: 'primary'
      })
      this.openPopup = false;
      this.initScreen();
    }).catch(() => {
    })
  },
  getLists: function () {
    this.$processor.post('/following-special-article/all', {}).then((response) => {
      this.responseData = response.data.followingSpecialArticles;
    })
  },
  editArticle: function (value) {
    this.form.id = value;
    const payload = {
      id: this.form.id
    }
    this.$processor.post('/following-special-article/find-by-id', payload).then((response) => {
      this.form = response.data.followingArticleSpecial;
      this.isUpdate = true;
      this.openPopup = true;

    }).catch(() => {
    });
  },
  deleteArticle: function () {
    this.$vs.loading();
    const payload = {
      id: this.form.id
    };
    this.$processor.post('/following-special-article/delete', payload).then((response) => {
      this.$vs.notify({
        text: this.$t('warningManager.textDeleteSource'),
        icon: 'feather',
        iconPack: 'icon-alert-circle',
        color: 'primary'
      })
      this.$vs.loading.close();
      this.initScreen();
    })
  },
  confirmDelete: function (value) {
    this.form.id = value;
    return this.$vs.dialog({
      type: 'confirm',
      color: 'danger',
      title: this.$t('warningManager.titleDelete'),
      text: this.$t('warningManager.textDelete2'),
      accept: this.deleteArticle,
      acceptText: this.$t('warningManager.acceptText'),
      cancelText: this.$t('warningManager.cancelText')
    })
  },
  openPopupCreate: function () {
    this.openPopup = true;
    this.form.articleResource = null;
    this.form.description = null;
    this.isUpdate = false;
  }
}
}
</script>
<style scoped>
.warning{
    border-radius: 10px;
    padding: 5px 10px 10px 10px;
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
    margin-top: 30px;
}
.rows-1{
  border: 1px solid #fff;
  padding : 0px 5px 0px 10px;
  background-color: #fff;
  border-radius: 5px;
}
.rows-2{
  border: 1px solid rgb(221 219 219 / 24%);
  padding : 0px 5px 0px 10px;
  background-color: #dae1e729;
  border-radius: 5px;
}
.rows{
  border: 1px solid rgb(245, 245, 246);
  padding : 0px 5px 5px 10px;
  background-color: rgb(245, 245, 246);
  border-radius: 5px;
  margin-top: 20px;
}
.text-topic{
  font-size: 15px;
  font-weight: bold;
}
.message-error{
  margin-left:15px
}
.icon{
  margin-right:20px;
  width:18px
}
.title-page{
  font-size: 2.2rem;
  font-weight: bold;
}
.minus-top{
  margin-top: -24px;
}
</style>
